import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Youtube, Instagram } from 'lucide-react';
import XpertLogo, { XpertWordmark } from './XpertLogo';
import { useConfig } from '../context/ConfigContext';

const columns = [
  { title: 'Product', links: ['Why Xpertpests', 'Features', 'Pricing', 'Mobile App', 'Integrations', 'Decision AI'] },
  { title: 'Solutions', links: ['Residential', 'Commercial', 'Multi-Unit', 'Termite', 'Mosquito', 'Lawn Care'] },
  { title: 'Resources', links: ['Blog', 'Case Studies', 'Webinars', 'Forms Library', 'API Docs', 'Community'] },
  { title: 'Company', links: ['About Us', 'Careers', 'Newsroom', 'Partners', 'Contact', 'Trust & Security'] },
];

export default function Footer() {
  const { contact } = useConfig();
  return (
    <footer className="bg-[#0d2818] text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <XpertLogo size={42}/>
              <XpertWordmark light size="md"/>
            </Link>
            <p className="text-sm leading-relaxed max-w-xs text-slate-400">{contact.tagline} Family-owned pest control serving Southern California.</p>
            <div className="mt-4 space-y-1 text-sm text-slate-400">
              <div>📍 {contact.address}</div>
              <div>📞 {contact.phone1} · {contact.phone2}</div>
              <div>✉ {contact.email}</div>
              <div>🌐 {contact.website}</div>
            </div>
            <div className="flex gap-3 mt-6">
              {[Facebook, Twitter, Linkedin, Youtube, Instagram].map((I, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#8BC53F] flex items-center justify-center transition">
                  <I className="w-4 h-4"/>
                </a>
              ))}
            </div>
          </div>
          {columns.map(c => (
            <div key={c.title}>
              <div className="text-white font-bold text-[13px] tracking-widest mb-4">{c.title.toUpperCase()}</div>
              <ul className="space-y-2.5">
                {c.links.map(l => (
                  <li key={l}><a href="#" className="text-sm text-slate-400 hover:text-white transition">{l}</a></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Xpertpests Solutions, Inc. All Rights Reserved.</div>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <a href="#" className="hover:text-white">Cookies</a>
            <a href="#" className="hover:text-white">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
